'use client';

import { useEffect, useRef } from 'react';

/** Еднократно увеличава viewCount за публикувана статия. */
export default function BlogViewCounter({ slug }) {
  const sent = useRef(false);

  useEffect(() => {
    if (sent.current || !slug) {
      return;
    }
    sent.current = true;
    fetch(`/api/blog/posts/${encodeURIComponent(slug)}/view`, { method: 'POST' }).catch(() => {});
  }, [slug]);

  return null;
}
